module.exports = __webpack_public_path__ + "media/public/img/logo-white-d94fa1abed81b67a048b3d0f0ab5b955.png";